import React from "react";
import {useAppSelector} from "../DAL/store";
import ProductPriceFormat from "../../products/product-price/product-price-format";
import {SubscriptionPlanModel} from "../interfaces";

interface IPriceProps {
    plan:SubscriptionPlanModel,
    isStarter:boolean,
    isAnnual?:boolean,
    isPopup?:boolean,
    caller?: string
}

export const Price = (props: IPriceProps) => {

    //console.log('Price', props);
    const PageData = useAppSelector((store) => store.PageData);
    let IsAnnual =  useAppSelector((store) => store.IsAnnual);
    if(props.isAnnual !== undefined){
        IsAnnual = props.isAnnual;
    }
    const tierEndsWith = props.isStarter ? "low":"high";

    const annualPlan = props?.plan ?? PageData.subscriptionPlans.filter(plan => {
        //if isStarter --> get annual starter plan ELSE get PremiumPlan annual plan
        return plan.sbsTypeID === 2 && plan.tierLowHigh.endsWith(tierEndsWith);
    })[0];


    return (
        <>
            {
                !IsAnnual &&
                <span><ProductPriceFormat price={ props.plan.skU_MSRP } /><span className="text-base font-normal"> / {IsAnnual ? "year":"month"}</span></span>
            }

            {
                IsAnnual &&
                <div className="flex items-center justify-center">
                    <div className="w-fit">
                        {/*annualPlan.skU_MSRP + 0.01 --> round the price up */}
                        {/*<ProductPriceFormat price={ (Math.ceil(annualPlan.skU_MSRP) ) / 12 } /><span className="text-base font-normal"> / month</span>*/}

                        <div><ProductPriceFormat price={ (Math.ceil(annualPlan.skU_MSRP) ) / 12 } /><span className="text-base font-normal"> / month</span></div>

                        <div className={`${props.isPopup ? "text-tiny":"text-base lg:text-base"} w-full font-normal`}>

                            <span className="text-white">
                                {(props?.caller ==='Plans' || props?.caller ==='PlansPricingDesignNew' || props?.caller ==='PlansPopup') &&
                                <span>Annual Subscription{" "}</span>}
                                <ProductPriceFormat price={ annualPlan.skU_MSRP } />
                                <span>{" "}billed upfront</span>
                            </span>

                        </div>

                    </div>

                </div>
            }
        </>
    )
};